export class VehicleProperties {
  sideNumber: string;
  [key: string]: any;

  static getName(): string {
    return 'VehicleProperties';
  }
}
